import {
  openPointPropsSwal,
  openBulkEditSwal
} from './portal-point-edit-ui.js'

const createPortalPointEditBaseContext = function (options) {
  return {
    _: options._,
    $: options.$,
    areaSwal: options.areaSwal,
    drawnItems: options.drawnItems,
    fnT: options.fnT,
    importMissionType: options.importMissionType,
    importMissionState: options.importMissionState,
    NON_EXPORT_POINT_HEIGHT_PATH: options.NON_EXPORT_POINT_HEIGHT_PATH,
    DEM_PROVIDER_PRIORITY: options.DEM_PROVIDER_PRIORITY,
    fnGetDemProviderLabel: options.fnGetDemProviderLabel,
    fnRunPointHeightDemOverwriteFlow: options.fnRunPointHeightDemOverwriteFlow,
    fnGetPointHeightToolFieldMeta: options.fnGetPointHeightToolFieldMeta,
    fnCaptureState: options.fnCaptureState,
    fnHistoryPush: options.fnHistoryPush,
    fnAttachSeekAxisLayerToModal: options.fnAttachSeekAxisLayerToModal,
    fnGetTemplateWaypointDefaults: options.fnGetTemplateWaypointDefaults,
    fnTemplateSupportsPointCoordinatesField: options.fnTemplateSupportsPointCoordinatesField,
    fnSortPointEditorRows: options.fnSortPointEditorRows,
    fnPropsMapToRows: options.fnPropsMapToRows,
    fnFilterPointEditorMapForMissionType: options.fnFilterPointEditorMapForMissionType,
    fnIsKmlActionPath: options.fnIsKmlActionPath,
    fnIsKmzActionPath: options.fnIsKmzActionPath,
    fnGetMissionAltitudeContextFor3d: options.fnGetMissionAltitudeContextFor3d,
    fnGetPointNumericByPathAliases: options.fnGetPointNumericByPathAliases,
    fnSyncRoute3dSharedState: options.fnSyncRoute3dSharedState,
    fnScheduleRoute3dSharedSync: options.fnScheduleRoute3dSharedSync,
    fnRefreshWaypointMarker: options.fnRefreshWaypointMarker,
    toFiniteNumber: options.toFiniteNumber,
    pathWithoutNamespacePrefixes: options.pathWithoutNamespacePrefixes,
    pathWithoutNumericParts: options.pathWithoutNumericParts,
    fnResolvePropPresetOptions: options.fnResolvePropPresetOptions,
    getPathLeafField: options.getPathLeafField,
    pathWithoutLeadingScope: options.pathWithoutLeadingScope,
    fnResolvePropLabelTooltip: options.fnResolvePropLabelTooltip,
    fnResolvePropLabelDetailedHelp: options.fnResolvePropLabelDetailedHelp,
    fnResolvePropLabelIconClass: options.fnResolvePropLabelIconClass,
    fnResolvePropLabelRequired: options.fnResolvePropLabelRequired,
    fnBuildHeadingSuggestModel: options.fnBuildHeadingSuggestModel,
    toUnixMs: options.toUnixMs,
    fnFormatUnixMsForDisplay: options.fnFormatUnixMsForDisplay,
    fnParseDisplayTimestampToUnixMs: options.fnParseDisplayTimestampToUnixMs,
    TIMESTAMP_DISPLAY_FORMAT: options.TIMESTAMP_DISPLAY_FORMAT,
    fnResolveI18Text: options.fnResolveI18Text,
    fnResolvePropValueHelp: options.fnResolvePropValueHelp,
    fnShowPropContextMenu: options.fnShowPropContextMenu,
    PROP_FIELD_DISABLE_RULES: options.PROP_FIELD_DISABLE_RULES
  }
}

const resolvePortalPointEditOptions = function (options) {
  if (typeof options === 'function') return options
  return function () { return options || {} }
}

const createPortalPointEditLaunchers = function (options) {
  const resolveOptions = resolvePortalPointEditOptions(options)

  const openPortalPointPropsSwal = function (title, point, onCoordsChange, onPropsChange) {
    const currentOptions = resolveOptions() || {}
    const baseContext = createPortalPointEditBaseContext(currentOptions)
    return openPointPropsSwal(title, point, onCoordsChange, onPropsChange, {
      ...baseContext,
      NON_EXPORT_PROJECT_FILENAME_PATH: currentOptions.NON_EXPORT_PROJECT_FILENAME_PATH,
      POINT_ELLIPSOID_HEIGHT_PATH_ALIASES: currentOptions.POINT_ELLIPSOID_HEIGHT_PATH_ALIASES,
      fnPropsToMap: currentOptions.fnPropsToMap,
      fnSetByPath: currentOptions.fnSetByPath,
      fnUpdatePointXmlByPath: currentOptions.fnUpdatePointXmlByPath,
      fnSyncPointActionFileSuffixWithNameWithContext: currentOptions.fnSyncPointActionFileSuffixWithNameWithContext,
      fnIsWaypointHeightPath: currentOptions.fnIsWaypointHeightPath,
      fnRecalculateEgm96EllipsoidForPoints: currentOptions.fnRecalculateEgm96EllipsoidForPoints,
      fnIsEllipsoidHeightPath: currentOptions.fnIsEllipsoidHeightPath,
      fnBuildPointCoordinatesText: currentOptions.fnBuildPointCoordinatesText,
      fnUpdatePointCoordinates: currentOptions.fnUpdatePointCoordinates,
      fnGetKmlActionsFromProps: currentOptions.fnGetKmlActionsFromProps,
      fnSetKmlActionsInProps: currentOptions.fnSetKmlActionsInProps,
      fnSetPointKmlActionsWithContext: currentOptions.fnSetPointKmlActionsWithContext,
      fnApplyKmzActionFileSuffixDisplayModeToGroups: currentOptions.fnApplyKmzActionFileSuffixDisplayModeToGroups,
      fnGetKmzActionGroupsFromProps: currentOptions.fnGetKmzActionGroupsFromProps,
      fnGetPointName: currentOptions.fnGetPointName,
      fnResolveKmzActionFileSuffixPointNameTokensInGroups: currentOptions.fnResolveKmzActionFileSuffixPointNameTokensInGroups,
      fnSetKmzActionGroupsInProps: currentOptions.fnSetKmzActionGroupsInProps,
      fnSetPointKmzActionGroupsWithContext: currentOptions.fnSetPointKmzActionGroupsWithContext
    })
  }

  const openPortalBulkEditSwal = function (points) {
    const currentOptions = resolveOptions() || {}
    const baseContext = createPortalPointEditBaseContext(currentOptions)
    return openBulkEditSwal(points, {
      ...baseContext,
      fnTF: currentOptions.fnTF,
      NON_EXPORT_PROJECT_FILENAME_PATH: currentOptions.NON_EXPORT_PROJECT_FILENAME_PATH,
      fnMergePropsForEdit: currentOptions.fnMergePropsForEdit,
      fnApplyEditsToPoints: currentOptions.fnApplyEditsToPoints,
      fnBuildSharedKmlActionsForPoints: currentOptions.fnBuildSharedKmlActionsForPoints,
      fnSetPointKmlActionsWithContext: currentOptions.fnSetPointKmlActionsWithContext,
      fnBuildSharedKmzActionGroupsForPoints: currentOptions.fnBuildSharedKmzActionGroupsForPoints,
      fnResolveKmzActionFileSuffixPointNameTokensInGroups: currentOptions.fnResolveKmzActionFileSuffixPointNameTokensInGroups,
      fnGetPointName: currentOptions.fnGetPointName,
      fnSetPointKmzActionGroupsWithContext: currentOptions.fnSetPointKmzActionGroupsWithContext
    })
  }

  return {
    openPortalPointPropsSwal: openPortalPointPropsSwal,
    openPortalBulkEditSwal: openPortalBulkEditSwal
  }
}

export {
  createPortalPointEditLaunchers
}
